import PropTypes from 'prop-types'
import React from 'react'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import * as yup from 'yup'
import { updateUserInformation } from '../actions/AuthAction'
import { yupToFormErrors } from '../components/Validator'
import * as routeService from '../services/routeService'
import * as translationService from '../services/translationService'
import { cleanApiErrorMessage, getApiErrorMessage } from './../utils/apiError'
import { Button, ErrorText, Form, TextField } from './../components'
import { REQUIRED_FIELD } from './../utils/validation/constants'
import AuthContent from './AuthContent'

class RegisterView extends React.Component {
  static propTypes = {
    getTacRequest: PropTypes.func,
    updateUserInformation: PropTypes.func,
    error: PropTypes.any,
    property: PropTypes.any,
    tac: PropTypes.any,
    newUser: PropTypes.object,
    user: PropTypes.object,
  }

  state = {
    firstname: '',
    lastname: '',
    inputValidation: {},
    serverErrorMessage: undefined,
  }

  componentDidMount() {
    const { user = { id: null } } = this.props
    if (!user.id) {
      routeService.goToLoginPage()
    }
  }

  validation = yup.object({
    firstname: yup.string().required(REQUIRED_FIELD),
    lastname: yup.string().required(REQUIRED_FIELD),
  })

  onValueChange = event => {
    const { id, value } = event.target
    this.setState({
      [id]: value,
    })
  }

  resetErrors = () => {
    this.setState({
      inputValidation: {},
      serverErrorMessage: undefined,
    })
  }

  onVerifyAccount = async event => {
    event.preventDefault()
    this.resetErrors()

    const payload = {
      firstname: this.state.firstname,
      lastname: this.state.lastname,
    }

    try {
      await this.validation.validate(this.state, { abortEarly: false })
      await this.props.updateUserInformation(payload)
      routeService.goToPath(routeService.getPrefixPath() + '/')
    } catch (error) {
      if (error.inner) {
        const validationErrors = yupToFormErrors(error)
        this.setState({
          inputValidation: validationErrors,
        })
      } else {
        // One general message for every API failure. The old v1 `error.details.codes` read threw
        // inside this catch, so nothing reached the screen at all, and a message that is not plain
        // user-facing copy is replaced by the generic one.
        const message = getApiErrorMessage(error.serverError)
        this.setState({
          serverErrorMessage: cleanApiErrorMessage(message) || translationService.generalError(),
        })
      }
    }
  }

  toggleModal = () => {
    this.setState(prevState => {
      return { tacModalisOpen: !prevState.tacModalisOpen }
    })
  }

  render() {
    const { error } = this.props
    const { inputValidation = {}, serverErrorMessage } = this.state
    const processedErrors = error
    return (
      <AuthContent
        title={translationService.registerCompleteProfileTitle()}
        // subtitle={translationService.registerCompleteProfileIntro()}
        hasToken={false}
        withSpacer={false}>
        <Form onSubmit={this.onVerifyAccount}>
          {serverErrorMessage && <ErrorText>{serverErrorMessage}</ErrorText>}
          <TextField
            label={translationService.registerFirstNameLabel()}
            id="firstname"
            autoFocus
            value={this.state.firstname}
            onChange={this.onValueChange}
            error={inputValidation.firstname || (processedErrors && processedErrors.firstname)}
          />
          <TextField
            label={translationService.registerLastNameLabel()}
            id="lastname"
            value={this.state.lastname}
            onChange={this.onValueChange}
            error={inputValidation.lastname || (processedErrors && processedErrors.lastname)}
          />
          <div>
            <Button submit primary onClick={this.onVerifyAccount}>
              {translationService.system('next')}
            </Button>
          </div>
        </Form>
      </AuthContent>
    )
  }
}

const mapStateToProps = ({ AuthReducer, FlowReducer }) => {
  const { error, newUser, user } = AuthReducer
  const { property } = FlowReducer

  return {
    property,
    error,
    newUser,
    user,
  }
}
const mapDispatchToProps = dispatch => ({
  updateUserInformation: userInformation => dispatch(updateUserInformation(userInformation)),
})

export default compose(
  translate('translations'),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(RegisterView)



// WEBPACK FOOTER //
// ./src/views/RegisterView.js